<template>
  <form class="sale-change-email">
    <snow-input
      v-model="form.email"
      id="email"
      type="email"
      label="E-mail novo"
      placeholder="Digite o novo e-mail"
      :errors="errors.email"
    />

    <div class="snow-submit-buttons mt-7">
      <snow-button
        text="Cancelar"
        variant="gray"
        size="lg"
        @click="$emit('close')"
      />
      <snow-button
        text="Salvar"
        type="submit"
        :loading="loading"
        size="lg"
        @click="submit"
      />
    </div>
  </form>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  props: {
    id: [Number, String]
  },
  data() {
    return {
      ...formFields(["email"]),
      loading: false
    };
  },
  methods: {
    submit() {
      this.loading = true;
      window.axios
        .put(`/gateways/order/${this.id}`, this.form)
        .then(() => {
          this.$message.success("E-mail trocado com sucesso");
          this.$store.commit("sale/setSale", {
            ...this.sale,
            shopper_email: this.form.email
          });
          this.$emit("success");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao trocar e-mail")
          );
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close");
        });
    }
  },
  computed: {
    ...mapState("sale", ["sale"])
  }
};
</script>
